import {
  AddMyFleetVesselsResponse,
  DeleteMyFleetVesselsResponse,
  MyFleetVessel,
  MyFleetVesselDeleteRequest,
  MyFleetVessels,
  MyFleetVesselUpdateRequest,
  UpdateMyFleetVesselsResponse,
} from '../models/my-fleet.model';
import { wrapRequest } from './base';

export const getMyFleetVessels = async (): Promise<MyFleetVessels> =>
  wrapRequest('get', 'north_standard', `/vessels`);

export const addMyFleetVessels = async (
  payload: MyFleetVessels
): Promise<AddMyFleetVesselsResponse> =>
  wrapRequest('post', 'north_standard', `/vessels`, {
    body: payload,
  });

export const deleteMyFleetVessels = async (
  payload: MyFleetVesselDeleteRequest
): Promise<DeleteMyFleetVesselsResponse> =>
  wrapRequest('del', 'north_standard', `/vessels`, {
    body: payload,
  });

export const updateMyFleetVessel = async (
  payload: MyFleetVessel
): Promise<UpdateMyFleetVesselsResponse> => {
  if (!payload.vessel_id) {
    throw new Error('vessel_id is required in the payload');
  }

  const updateRequest: MyFleetVesselUpdateRequest = {
    vessel_id: payload.vessel_id,
    name: payload.name,
    vessel_type: payload.vessel_type,
  };

  return wrapRequest('patch', 'north_standard', `/vessels`, {
    body: updateRequest,
  });
};
